import styled from 'styled-components';

import { breakpoints } from '~/src/features/tariffLines/styled';

export const Logo = styled.a`
    flex: 0;
    display: flex;
    justify-content: center;
    max-width: 100%;
`;

export const LogoImg = styled.img<{ maxWidth?: string }>`
    flex: 0;
    width: auto;
    height: auto;
    max-width: ${p => p.maxWidth ?? '128px'};
    max-height: 48px;

    @media (max-width: ${breakpoints.sMobile}) {
        max-width: ${p => p.maxWidth ?? '100px'};
    }
`;
